import * as v from "valibot"

const pluralizeCz = (count: number, one: string, few: string, many: string) => {
    const mod10 = count % 10;
    const mod100 = count % 100;

    if (mod10 === 1 && mod100 !== 11) {
        return `${count} ${one}`;
    }

    if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) {
        return `${count} ${few}`;
    }

    return `${count} ${many}`;
};

const asNumber = (value: unknown) => {
    if (typeof value === "number") {
        return value;
    }

    if (typeof value === "bigint") {
        return Number(value);
    }

    const parsed = Number(value);
    return Number.isNaN(parsed) ? undefined : parsed;
};

v.setGlobalMessage(() => "Neplatná hodnota", "cs");

v.setSpecificMessage(v.string, () => "Prosím vyplňte", "cs");
v.setSpecificMessage(v.number, () => "Zadejte číslo", "cs");
v.setSpecificMessage(v.integer, () => "Zadejte celé číslo", "cs");
v.setSpecificMessage(v.safeInteger, () => "Zadejte celé číslo v povoleném rozsahu", "cs");
v.setSpecificMessage(v.boolean, () => "Prosím vyberte", "cs");
v.setSpecificMessage(v.bigint, () => "Zadejte číslo", "cs");
v.setSpecificMessage(v.date, () => "Zadejte platné datum", "cs");

v.setSpecificMessage(v.email, () => "Zadejte platný e-mail", "cs");
v.setSpecificMessage(v.url, () => "Zadejte platnou URL adresu", "cs");
v.setSpecificMessage(v.regex, () => "Nesprávný formát", "cs");
v.setSpecificMessage(v.nonEmpty, () => "Pole nesmí být prázdné", "cs");

v.setSpecificMessage(
    v.minLength,
    (issue) => {
        const requirement = asNumber(issue.requirement) ?? 0;
        return `Zadejte alespoň ${pluralizeCz(requirement, "znak", "znaky", "znaků")}`;
    },
    "cs"
);

v.setSpecificMessage(
    v.maxLength,
    (issue) => {
        const requirement = asNumber(issue.requirement) ?? 0;
        return `Zadejte nejvýše ${pluralizeCz(requirement, "znak", "znaky", "znaků")}`;
    },
    "cs"
);

v.setSpecificMessage(
    v.minValue,
    (issue) => {
        const requirement = issue.requirement;
        return `Zadejte hodnotu ≥ ${requirement}`;
    },
    "cs"
);

v.setSpecificMessage(
    v.maxValue,
    (issue) => {
        const requirement = issue.requirement;
        return `Zadejte hodnotu ≤ ${requirement}`;
    },
    "cs"
);


v.setSpecificMessage(v.array, () => "Vyberte alespoň jednu položku", "cs");
v.setSpecificMessage(v.object, () => "Vyplňte požadované údaje", "cs");

v.setSpecificMessage(
    v.minSize,
    (issue) => {
        const requirement = asNumber(issue.requirement) ?? 0;
        return `Vyberte alespoň ${pluralizeCz(requirement, "položku", "položky", "položek")}`;
    },
    "cs"
);

v.setSpecificMessage(
    v.maxSize,
    (issue) => {
        const requirement = asNumber(issue.requirement) ?? 0;
        return `Vyberte nejvýše ${pluralizeCz(requirement, "položku", "položky", "položek")}`;
    },
    "cs"
);

v.setSpecificMessage(v.literal, (issue) => `Povolená hodnota je ${String(issue.requirement)}`, "cs");
v.setSpecificMessage(v.enum, () => "Vyberte jednu z nabízených možností", "cs");

v.setGlobalConfig({ lang: "cs" });